// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"520":"3fb81b24","644":"6781b19e"}[chunkId] + ".chunk.js";
};